var map = {
	"./Diamonds-series-500x500-e.png": 7489,
	"./Huetech-dark-logo.png": 3654,
	"./Magicpad Series.png": 1632,
	"./PT Sport Series960×960_e.png": 2409,
	"./PT-960X960-e.png": 1542,
	"./PT320-e.png": 9032,
	"./PTF 1000X1000_e.png": 1683,
	"./PTS_500x1000_e.png": 4489,
	"./PTpor_1200x900_e.png": 2285,
	"./T-max_e.png": 3818,
	"./T-series-e.png": 6187,
	"./TMAXCOB_e.png": 3857,
	"./Thinpad_e.png": 5591,
	"./Tiles028_1K-PNG_Color.jpg": 1495,
	"./image1.png": 5927,
	"./image13.png": 924,
	"./image2.png": 7452,
	"./imageloby.PNG": 8451,
	"./imageloby2.png": 7480,
	"./imgHeaderpdf.png": 8143,
	"./inpadMAX-500X1000_e.png": 7176,
	"./one-tile.jpg": 6322,
	"./pdfImage.jpeg": 9979,
	"./preview.gif": 5540,
	"./sun.jpg": 9953,
	"./wall.jpg": 3383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;